import { 
    memo, 
    useEffect, 
    useRef, 
    useState 
} from 'react';
import axios from 'axios';

// componentes
import AsyncCreatableSelect from 'react-select/lib/AsyncCreatable';
import OptionSelect from './OptionSelect';

import './index.css';

// componente
function ComboAtividades({
    atividades,
    onChange,
    idsGruposAtividades=['1','2']
}) {
    const refSelect = useRef(null);
    const colandoTexto = useRef(false);

    // faz a consulta
    async function consultar(inputValue, callback = null, textos=[]){
        // se estiver colando, não continua a execução
        if(colandoTexto.current) return;

        try {

            // prepara os parametros para a consulta
            const params = {
                idsGruposAtividades,
                registrosPorPagina: 7
            }

            // se for um array de textos
            if(textos.length > 0) {
                params['textos'] = textos;
            } else {
                // se for texto pesquisado
                params['texto'] = inputValue;
            }

            // faz a requisição
            const { data } = await axios.get(`/atividades`, {
                params: {
                    ...params
                }
            });

            // filtra registros, desabilita quem já está na lista
            const registros = data.registros.map(atividadeRegistro => {
                // verifica se já está adicionado
                if(atividades.find(atividadesFind => {
                    if(atividadesFind.id === atividadeRegistro.id){
                        return true;
                    }
                    return false;
                })){
                    atividadeRegistro.isDisabled = true;
                }
                return atividadeRegistro;
            });
            
            // se foi passado callback (foi pesquisado no componente)
            if(callback !== null) {
                callback(registros);
            } else if(textos.length > 0) {                
                // dispara função, mantendo os antigos, adicionando os novos e removendo duplicados
                onChange([
                    ...atividades,
                    ...registros.filter(nova => 
                        !atividades.some(e => e.id === nova.id)
                    )
                ])
            }
        } catch({ response }){
            console.log(response);
        }        
    }
    
    // função para lidar com o evento de colar no componente
    async function eventoColar(e) {
        colandoTexto.current = true;

        e.preventDefault();

        // resgata texto que está colado
        const textoColado = await navigator.clipboard.readText();
        if(typeof textoColado !== "string") return;

        // resgata textos por linha
        const textos = textoColado
            .split(/\r?\n/)
            .map(item => 
                item
                    .trim()
                    .replace(/[^\p{L}\p{N}\s]/gu, '')
            )
            .filter(Boolean)
        ;
        
        colandoTexto.current = false;

        // consulta os textos
        consultar(null, null, textos);
    }

    return (
        <div onPaste={eventoColar}>
            <AsyncCreatableSelect
                ref={refSelect}
                isMulti
                loadOptions={consultar}
                options={atividades}
                value={atividades.map(atividade => {
                    return {
                        label: atividade.nome, 
                        value: atividade.id
                    }
                })}
                components={{ Option: OptionSelect }}
                onChange={(_, validar) => {
                    // verifica ações
                    if(validar.action === 'pop-value') {
                        atividades.pop();
                        onChange([...atividades]);
                    } else if(validar.action === 'remove-value') {
                        // dispara alteração
                        onChange(atividades.filter((atv) => {                            
                            if(atv.id === validar.removedValue.value) {
                                return false;
                            }
                            return true
                        }));
                    } else if(validar.action === 'clear') {
                        onChange([]);
                    } else if(validar.action === 'select-option') {
                        onChange([...atividades, validar.option]);
                    }
                }}
                loadingMessage={() => 'Carregando...'}
                noOptionsMessage={() => 'Digite para encontrar a atividade'}
                placeholder={idsGruposAtividades.length > 1 ? 'Atividades' : `Atividades do grupo ${idsGruposAtividades[0]}`}
                className={'react-select-container'}
                classNamePrefix="react-select"
            />
        </div>
    )
}

export default memo(ComboAtividades);